const $cache = {};

const initCache = () => {
    $cache.contentSlider = $(".content-plus-carousel");
    $cache.isSliderInit = $cache.contentSlider.find("img").length > 1;
    $cache.speed = $cache.contentSlider.data("speed") ? $cache.contentSlider.data("speed") : "3000";
    $cache.dots = $cache.contentSlider.data("dots") ? $cache.contentSlider.data("dots") : false;
    $cache.dotsLarge = $cache.contentSlider.data("dots-large") ? $cache.contentSlider.data("dots-large") : false;
    $cache.circleAnimation = $(".circle-animation");
    $cache.disableArrows = $cache.contentSlider.data("disable-arrows") ? $cache.contentSlider.data("disable-arrows") : false;
    $cache.disableArrowsLarge = $cache.contentSlider.data("disable-arrows-large") ? $cache.contentSlider.data("arrows-large") : false;
    $cache.disableAutoPlay = $cache.contentSlider.data("disable-auto-play") ? $cache.contentSlider.data("disable-auto-play") : false;
};

let countdownPaused = false;

const countdown = () => {
    var countdownTime = $cache.speed / 1000;

    $cache.circleAnimation.css("animation-duration", countdownTime + "s");
};

/**
* Handles click events on elements with the `.js-countdown` class to toggle the play/pause state
* of a content slider and update the countdown status display accordingly.
*
* @listens click
* @fires $cache.contentSlider.slick("slickPlay")
* @fires $cache.contentSlider.slick("slickPause")
* @modifies countdownPaused
* @modifies .js-countdown-status text and classes
*/
$(".js-countdown").on("click", function() {
    let $this = $(this);
    let $countdownStatus = $this.find(".js-countdown-status");

    if (countdownPaused) {
        $cache.contentSlider.slick("slickPlay");
        countdownPaused = false;
        $countdownStatus.text($this.attr("data-status-playing-text")).removeClass("paused").addClass("playing");
    } else {
        $cache.contentSlider.slick("slickPause");
        countdownPaused = true;
        $countdownStatus.text($this.attr("data-status-paused-text")).removeClass("playing").addClass("paused");
    }
});

const initEvents = () => {
    if ($cache.contentSlider.length > 0 && $cache.isSliderInit) {
        $cache.contentSlider.slick({
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            speed: 500,
            centerMode: false,
            fade: true,
            cssEase: "linear",
            autoplay: !$cache.disableAutoPlay,
            autoplaySpeed: $cache.speed,
            pauseOnHover: false,
            dots: $cache.dots,
            arrows: !$cache.disableArrows,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        dots: $cache.dotsLarge,
                        arrows: !$cache.disableArrowsLarge
                    }
                }
            ]
        });
    }
};

/**
 *  Set aspect ratio box class and styles
 */
const initImageRatioBox = () => {
    let paddingBotttom = $(".content-plus-carousel").data("padding-bottom");
    const $imgContainer = $(".content-plus-item");

    if ($imgContainer.length && paddingBotttom) {
        $imgContainer.each(function () {
            $(this).find("picture").addClass("ratio-container").attr("style", paddingBotttom ? "--padding:" + paddingBotttom + "%" : "");
        });
    }
};

export default function () {
    initCache();
    initEvents();
    countdown();
    initImageRatioBox();

    $cache.circleAnimation.addClass("start");

    $cache.contentSlider.on("beforeChange", () => {
        $cache.circleAnimation.removeClass("start");
    });

    $cache.contentSlider.on("afterChange", () => {
        countdown();
        $cache.circleAnimation.addClass("start");
    });
}
